__turbopack_context__.v({
  "container": "LocationSelect-module-scss-module__xcKhhG__container",
  "input": "LocationSelect-module-scss-module__xcKhhG__input",
  "options": "LocationSelect-module-scss-module__xcKhhG__options",
});
